export const SET_MODEL_LIST = 'SET_MODEL_LIST';
export const SET_BRAND_LIST = 'SET_BRAND_LIST';
export const SET_FILE_LIST = 'SET_FILE_LIST';
export const SET_SUBMITTED = 'SET_SUBMITTED';
